agents<template lang="html">
  <article class="">
    <h3 style="text-align: center; font-size: 20px">Nuevo agente</h3>
    <v-container fluid>
      <v-layout row wrap>
        <v-flex xs>
          <form @submit="checkForm" method="post">
            <section>
              <!-- Nombre -->
              <v-text-field
                name="name"
                label="Nombre"
                type="text"
                required
                v-model="agent.user_info_attributes.name"></v-text-field>
              <!-- Apellido -->
              <v-text-field
                name="last_name"
                label="Apellido"
                type="text"
                required
                v-model="agent.user_info_attributes.last_name"></v-text-field>


              <!-- Fecha de expiración -->
              <v-flex xs12>
                <label>Género</label>
                <v-select
                  v-model="agent.user_info_attributes.gender"
                  :items="genders"
                  item-text="attributes.name"
                  label="Género"
                  persistent-hint
                  return-object
                  single-line
                  required
                ></v-select>
              </v-flex>
              <!-- Fotos de la oferta -->


              <!-- Category -->
              <v-flex xs12>
                <label>Locación</label>
                <v-select
                  v-model="location_selected"
                  :items="locations"
                  item-text="attributes.name"
                  label="Locación"
                  persistent-hint
                  required
                  return-object
                  single-line
                ></v-select>
              </v-flex>

              <v-text-field
                name="mobile"
                label="Teléfono"
                type="number"
                required
                v-model="agent.attributes.mobile"
                ></v-text-field>

              <v-flex xs12>
                <label>Correo</label>
                <v-text-field
                  prepend-icon="person"
                  name="email"
                  label="Correo"
                  persistent-hint
                  required
                  return-object
                  single-line
                  type="email"
                  v-model="agent.attributes.email"></v-text-field>
                </v-flex>


                <v-flex xs12>
                  <label>Contraseña</label>
                  <v-text-field
                    id="password"
                    prepend-icon="lock"
                    name="password"
                    label="Contraseña"
                    persistent-hint
                    return-object
                    required
                    single-line
                    type="password"
                    v-model="agent.attributes.password"></v-text-field>
                </v-flex>

                <v-flex xs12>
                  <label>Confirmar contraseña</label>
                  <v-text-field
                    id="password_confirmation"
                    prepend-icon="lock"
                    name="password_confirmation"
                    label="Confirmar contraseña"
                    persistent-hint
                    return-object
                    required
                    single-line
                    type="password"
                    v-model="agent.attributes.password_confirmation"></v-text-field>
                </v-flex>

              <v-btn
                color="blue"
                type="submit">Crear</v-btn>


            </section>
          </form>

        </v-flex>

      </v-layout>
    </v-container>
  </article>
</template>

<script>
export default {
  data(){
    return{
      genders:["m","f"],
      is_valid: false,
      locations:'',
      location_selected:'',
      agent:{
        user_info_attributes:{
          name: '',
          last_name: '',
          gender: '',
          location_id: '',
        },
        attributes:{
          email: '',
          password: '',
          password_confirmation: '',
          user_info_type: 'Agent',
          mobile: '',
        }
      }
    }
  },
  mounted(){
    this.findLocations()
    const data={company:{id:this.getCompany().id}}
    try {
      this.$http.post('locations/company',{data:this.encrypt(data).toString()},{
            headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
            }
        })
      .then(function(response){
        this.locations= response.body.data
      }, function(response){
        if(typeof response.body.errors[0].details != "object"){
          alert(response.body.errors[0].details);
        }else{
          let message = []
          for(var key in response.body.errors[0].details){
            message.push(response.body.errors[0].details[key])
          }
          alert(message);
        }
      })
    } catch (e) {
      alert(e.message)
    }

  },
  methods:{
    checkForm: function(e) {
        e.preventDefault()
        try {
          this.agent.user_info_attributes.location_id=this.location_selected.id
          this.$http.post('agents',{
            data: this.encrypt(this.agent).toString()
          },{
            headers: {
              "X-Device-ID" : this.getDeviceId(),
               "Authorization" : 'Bearer ' + this.getUserToken()
            }
          }).then(function(response){
            this.$router.push({name: 'agent'})
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
          }, function(response){
            if(response.body.meta != undefined && response.body.meta != null){
              if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
                this.checkToken(response.body.meta.authentication_token)
              }
            }
            if(typeof response.body.errors[0].details != "object"){
              alert(response.body.errors[0].details);
            }else{
              let message = []
              for(var key in response.body.errors[0].details){
                message.push(response.body.errors[0].details[key])
              }
              alert(message);
            }
          })
        } catch (e) {
          alert(e.message)
        }

    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/agents/New_agent.vue